/**
 * Relay for Artist Page
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const ArtistPageQuery = graphql`
  query artist_Query($slug: String) {
    artist(slug: $slug) {
      ...artistFragment_artist
    }
  }
`;

export const ArtistFragment = graphql`
  fragment artistFragment_artist on Artist {
    ...artistNode @relay(mask: false)
  }
`;

export const artistNode = graphql`
  fragment artistNode on Artist {
    id
    name
    slug
    bio
    bandcamp
    facebook
    instagram
    itunes
    soundcloud
    spotify
    twitter
    wiki
    youtube
    homebase
    assets{
      ...assetNode @relay(mask: false)
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/artist.ts